module.exports = __webpack_public_path__ + "static/media/job-ad.36908c73.png";